function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  fill: "#5592C8",
  d: "M26.92 41.65l-.25-.3C21.84 35.4 16.21 29.8 10.75 24.38 7.27 20.92 3.66 17.34.34 13.74L0 13.36l.39-.34C3.57 10.28 9.16 4.85 13.02.49l.16-.18.24.01c.82.03 1.64.04 2.48.04 2.24 0 6.04-.08 10.07-.17 6.96-.15 14.16-.3 15.6-.1l.19.03.12.15c1.12 1.37 2.88 3.17 4.75 5.07 2.39 2.43 4.86 4.95 6.24 6.84l.21.29-.2.29c-4.01 5.82-24.47 28.2-25.59 28.72l-.37.17zM1.43 13.44c3.21 3.46 6.67 6.9 10.03 10.23 5.35 5.32 10.88 10.81 15.67 16.66 2.61-2.5 20.21-21.53 24.7-27.84-1.37-1.8-3.69-4.16-5.93-6.45-1.81-1.85-3.53-3.59-4.68-4.98-1.75-.16-8.91-.01-15.25.13-4.03.08-7.84.17-10.09.17-.77 0-1.53-.01-2.28-.04-3.71 4.19-8.96 9.31-12.17 12.12z"
});

var _ref3 =
/*#__PURE__*/
React.createElement("path", {
  fill: "#5592C8",
  className: "st4",
  d: "M3.4 13.61c-.77 0-1.37-.02-1.76-.06l-.18-.02-.22-.22.47-.47.03-.28c1.49.15 6.33-.04 12.44-.29 6.74-.27 15.13-.6 22.34-.6 2.44 0 5.26.08 7.99.16 2.71.08 5.52.16 7.94.16v1c-2.43 0-5.25-.08-7.97-.16-2.72-.08-5.53-.16-7.96-.16-7.19 0-15.57.33-22.3.6-4.62.18-8.51.34-10.82.34z"
});

var _ref4 =
/*#__PURE__*/
React.createElement("path", {
  fill: "#5592C8",
  className: "st4",
  d: "M17.87 13.23l-.26-.87c-.64-2.11-1.49-4.16-2.31-6.14-.67-1.61-1.36-3.28-1.95-4.99l.95-.32c.57 1.68 1.26 3.33 1.93 4.93.72 1.74 1.46 3.52 2.07 5.37 1.22-1.44 2.42-2.92 3.58-4.37 1.7-2.11 3.46-4.29 5.29-6.33l.37-.41.37.4c3.23 3.49 6.1 7.01 8.52 10.46 1.83-3.47 2.69-6.49 3.6-10.03l.97.25c-.96 3.71-1.93 7.1-4.08 10.97l-.39.71-.46-.67c-2.4-3.5-5.27-7.07-8.52-10.62-1.68 1.9-3.31 3.92-4.89 5.88-1.36 1.68-2.76 3.42-4.18 5.07l-.61.71z"
});

var _ref5 =
/*#__PURE__*/
React.createElement("path", {
  fill: "#5592C8",
  className: "st4",
  d: "M28.48 40.22l-.93-.37c3.9-9.85 6.38-18.05 8.56-28.32l.98.21c-2.19 10.33-4.69 18.58-8.61 28.48zM26.54 40.18c-1.19-4.07-2.81-8.57-4.52-13.33-1.61-4.47-3.28-9.1-4.72-13.74l.96-.3c1.44 4.63 3.1 9.24 4.71 13.7 1.72 4.78 3.35 9.29 4.54 13.39l-.97.28z"
});

var SvgRare = function SvgRare(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    id: "Layer_1",
    x: 0,
    y: 0,
    viewBox: "0 0 53.07 41.65",
    style: {
      enableBackground: "new 0 0 53.07 41.65"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgRare, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/rare.c88a6e58.svg";
export { ForwardRef as ReactComponent };